import React from 'react';
import { useNavigate } from 'react-router-dom';
import logoRD from './assets/logoasesor.png';
import fotoAsesor from './assets/asesor.jpg';
import './styles/disenocontacto.css';

export default function Contacto() {
  const navigate = useNavigate();

  return (
    <div className="contacto-container">
      {/* HEADER */}
      <header className="contacto-header">
        <div className="contacto-header-left">
          <img src={logoRD} alt="Logoasesor" className="contacto-logo" />
        </div>
        <nav className="contacto-nav">
          <span onClick={() => navigate("/")} className="contacto-nav-link">Menu Principal</span>
          <span onClick={() => navigate("/pantallaCIT")} className="contacto-nav-link">Asesoría</span>
          <span onClick={() => navigate("/", { state: { scrollTo: "planes" } })} className="contacto-nav-link">Planes de ahorro</span>
          <span onClick={() => navigate("/", { state: { scrollTo: "simulador" } })} className="contacto-nav-link">Simulador</span>
          <span onClick={() => navigate("/", { state: { scrollTo: "seguros" } })} className="contacto-nav-link">Seguros</span>
          <span onClick={() => navigate("/contacto")} className="contacto-nav-link">Contacto</span>
          <span onClick={() => navigate("/blog")} className="contacto-nav-link">Blog</span>
        </nav>
        <div className="contacto-header-info">
          📞 +52 (653) 103-8410 | ✉️ ricardodiaztuasesorfinanciero@gmail.com
        </div>
      </header>

      {/* SECCIÓN DE CONTACTO */}
      <section className="contacto-section">
        <h2 className="contacto-title">Contacto</h2>

        <div className="contacto-content">
          {/* FOTO Y DATOS */}
          <div className="contacto-card">
            <img
              src={fotoAsesor}
              alt="Asesor financiero Ricardo Díaz"
              className="contacto-photo"
            />
            <div className="contacto-info">
              <p><strong>Nombre:</strong> Ricardo Diaz</p>
              <p><strong>Edad:</strong> 36 años</p>
              <p><strong>Ubicación:</strong><br />
                Cjón. Oaxaca y 26, Plaza Eliza,<br />
                Local 8, 2do piso, arriba de CFE
              </p>
              <p><strong>Teléfono:</strong> +52 (653) 103-8410</p>
              <p><strong>Correo:</strong> ricardodiaztuasesorfinanciero@gmail.com</p>
            </div>
          </div>

          {/* MISION Y VISION */}
          <div className="contacto-mission">
            <h3 className="contacto-subtitle">Misión</h3>
            <p className="contacto-text">
              "Brindar soluciones financieras personalizadas que protejan el patrimonio y aseguren el futuro de nuestros clientes. A través de asesoría experta en inversiones, planes de retiro, seguros y protección familiar, ayudamos a construir estabilidad y tranquilidad financiera con estrategias adaptadas a cada necesidad."
            </p>

            <h3 className="contacto-subtitle">Visión</h3>
            <p className="contacto-text">
              "Ser el referente en asesoría financiera integral, ofreciendo productos innovadores y estrategias sólidas que permitan a nuestros clientes alcanzar sus metas de inversión, protección y bienestar. Buscamos transformar la manera en que las personas planifican su futuro, promoviendo educación financiera y confianza en cada decisión."
            </p>

            <p className="contacto-cta">
              ¿Te interesa tener una asesoría conmigo?<br />
              ¡Agenda una cita ahora mismo!
            </p>

            <button onClick={() => navigate("/pantallaCIT")} className="contacto-button">AGENDAR</button>
          </div>
        </div>
      </section>
    </div>
  );
}



